import React from 'react';
import style from './confirmationDialog.module.scss';
import { Modal } from 'acscp/components/common/modal';

interface ConfirmationDialogProps {
    isOpen: boolean;
    closeDialog: () => void;
    modalHeaderContent: JSX.Element;
    confirmationContent: JSX.Element;
    leftButtonContent: JSX.Element;
    leftButtonGreyedOut?: boolean;
    leftButtonOnClick: () => void;
    rightButtonContent: JSX.Element;
    rightButtonGreyedOut?: boolean;
    rightButtonOnClick: () => void;
}

const ConfirmationDialog: React.SFC<ConfirmationDialogProps> =
    ({
        isOpen,
        closeDialog,
        modalHeaderContent,
        confirmationContent,
        leftButtonContent,
        leftButtonGreyedOut,
        leftButtonOnClick,
        rightButtonContent,
        rightButtonGreyedOut,
        rightButtonOnClick
    }) => (
        <Modal
            isOpen={isOpen}
            closeModal={closeDialog}
            modalClassName={style.Modal}
            modalHeaderClassName={style.ModalHeader}
            modalBodyClassName={style.ModalBody}
            closingModalClassName={style.Cross}
            modalHeaderContent={modalHeaderContent}
        >
            <div>
                {confirmationContent}
            </div>
            <div className={style.Buttons}>
                <button className={leftButtonGreyedOut ? style.GreyedOutButton : ''} onClick={leftButtonOnClick}>
                    {leftButtonContent}
                </button>
                <button className={rightButtonGreyedOut ? style.GreyedOutButton : ''} onClick={rightButtonOnClick}>
                    {rightButtonContent}
                </button>
            </div>
        </Modal>
    );

export { ConfirmationDialog };
